// Nyelvválasztó.
//
// A weben eddig NEM volt: a szótár mindkét nyelven megvolt (hu és en), a
// betöltés viszont fixen magyar volt, tehát az angol soha nem jelent meg.
//
// Szegmentált vezérlő (`.seg`), nem legördülő: két nyelvnél a legördülő egy
// fölösleges kattintás, és a jelenlegi állapot sem látszik belőle egy
// pillantásra.
//
// A nyelv NEVE A SAJÁT NYELVÉN áll („Magyar", „English"), nem lefordítva.
// Aki angolul keresi a felületet, az az „English" szót ismeri fel, nem az
// „Angol"-t.

import { h } from './dom';
import { language, setLanguage, type Language } from './i18n';

const NYELVEK: { kod: Language; nev: string; rovid: string }[] = [
  { kod: 'hu', nev: 'Magyar', rovid: 'HU' },
  { kod: 'en', nev: 'English', rovid: 'EN' },
];

/// `rovid`: szűk helyen (fejléc) a két betűs alak, egyébként a teljes név.
export function nyelvValaszto(options: { rovid?: boolean } = {}): HTMLElement {
  const mostani = language();

  return h(
    'div',
    {
      class: `seg nyelv-valaszto${options.rovid ? ' nyelv-valaszto-rovid' : ''}`,
      role: 'group',
      // A csoportnak van neve, de a benne levo gomboknak is: a
      // kepernyoolvaso igy nem csak annyit mond, hogy „Magyar", hanem azt is,
      // mire valo.
      'aria-label': mostani === 'hu' ? 'Nyelv' : 'Language',
    },
    ...NYELVEK.map((ny) =>
      h('button', {
        class: ny.kod === mostani ? 'on' : '',
        type: 'button',
        lang: ny.kod,
        'aria-pressed': String(ny.kod === mostani),
        'aria-label': ny.nev,
        text: options.rovid ? ny.rovid : ny.nev,
        onClick: () => setLanguage(ny.kod),
      }),
    ),
  );
}
